import NotFound from '@components/NotFound/NotFound'
import {
  DASHBOARD_LINK,
  ROUTE_AI_SITEMAP_NEW,
  ROUTE_PAGE_HOME,
} from '@components/Router/constants'
import { useRedirectAfterAuth } from '@components/Router/hooks/useRedirectAfterAuth'
import type { AppState } from '@store/types'
import type React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom'

import { useAuth, useGenerateProject } from '@/hooks'
import { Main } from './Main'

// Все руты, ведущие в ArtBoard ('/', '/ai-sitemap/new-project', '/:uuid'),
// рендерят один и тот же компонент: разные обёртки перемонтировали бы всё
// дерево Main при push('/{id}') после создания или генерации проекта
export const MainRoot: React.FC = () => {
  const { pathname } = useLocation()
  const [params] = useSearchParams()

  const { uuid = null } = useParams<{ uuid: string }>()

  const { authenticated, setupCompleted } = useAuth()
  const error = useSelector<AppState, string | null>((state) => state.ui.error)

  const generateProject = useGenerateProject()
  const generationTheme = params.get('generationTheme')
  const aiNewRoute = pathname === ROUTE_AI_SITEMAP_NEW

  useRedirectAfterAuth()

  useEffect(() => {
    if (aiNewRoute && generationTheme) {
      generateProject(generationTheme)
    }
  }, [params])

  if (error && uuid) {
    return <NotFound />
  }

  if (pathname === ROUTE_PAGE_HOME && authenticated && setupCompleted) {
    return <Navigate to={DASHBOARD_LINK} replace />
  }

  if (aiNewRoute && !generationTheme) {
    return <Navigate to={DASHBOARD_LINK} replace />
  }

  return <Main />
}
